// Generated Module Configuration
export const moduleConfig = {
  "moduleConfig": {
    "name": "New Module",
    "description": "",
    "size": "medium",
    "theme": "uplynk",
    "endpoints": [
      {
        "root_url": "https://services.uplynk.com/api/v4",
        "path": "/ingest/external/jobs",
        "method": "POST",
        "category": "Smartplay Ingest",
        "parameters": {
          "job_type": {
            "type": "string",
            "examples": "live",
            "required": true,
            "help": "External ingest job type",
            "displayName": "Live / VOD",
            "placeholder": "",
            "helpText": "",
            "inputElement": "select"
          },
          "slicer_id": {
            "type": "string",
            "examples": "aws_ingest",
            "required": true,
            "help": "Ingest Live: slicer_id / Ingest Vod: vod_slicer",
            "displayName": "Give it a unique ID",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "url": {
            "type": "string",
            "examples": "https://c4af3793bf76b33c.mediapackage.us-west-2.amazonaws.com/out/v1/a2a60bf0d27049058a175a3f968ded34/index.m3u8",
            "required": true,
            "help": "BYOE ExternalIngestJob Description",
            "displayName": "URL to Pull from",
            "placeholder": "",
            "helpText": "",
            "inputElement": "textarea"
          },
          "desc": {
            "type": "string",
            "examples": "BYOE ExternalIngestJob",
            "required": false,
            "help": "BYOE ExternalIngestJob Description",
            "displayName": "Hidden - Match to Channel - desc",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "persist_segments": {
            "type": "boolean",
            "examples": "false",
            "required": false,
            "help": "Boolean flag that determines if segments should be persisted to cloud storage",
            "displayName": "Store Segments",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox"
          },
          "metadata": {
            "type": "object",
            "examples": {
              "external_id": "",
              "drm_mode": "none",
              "meta": {}
            },
            "required": false,
            "help": "Live or VOD External Ingest",
            "displayName": "metadata",
            "placeholder": "",
            "helpText": "",
            "inputElement": "json"
          },
          "state": {
            "type": "string",
            "examples": "NEW",
            "required": false,
            "help": "Set Desired State, NEW, SCHEDULED",
            "displayName": "state - hidden",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          }
        }
      },
      {
        "root_url": "https://services.uplynk.com",
        "path": "/api2/channel/create",
        "method": "POST",
        "category": "Channel",
        "parameters": {
          "desc": {
            "type": "string",
            "examples": "Sports Channel",
            "required": true,
            "displayName": "Channel Title",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "slicer_id": {
            "type": "string",
            "examples": "srt_slicer_1",
            "required": false,
            "displayName": "Source ID",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "require_drm": {
            "type": "integer",
            "examples": "0",
            "required": false,
            "displayName": "require_drm",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox",
            "checkboxToInteger": true
          },
          "require_studio_drm": {
            "type": "integer",
            "examples": "0",
            "required": false,
            "displayName": "require_studio_drm",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox",
            "checkboxToInteger": true
          }
        }
      }
    ],
    "callbacks": {
      '/ingest/external/jobs': {
        "afterResponse": {
          "actions": [
            {
              "action": 'appendState',
              "config": {
                "state": 'done',
                "messageTemplate": {"title": "Created Ingest", "value": "{ingest_id}"},
                "extractMapping": {
                  "ingest_id": 'data.id',
                  "progress": 100
                }
              }
            }
          ]
        },
        "onError": {
          "actions": [
            // Error handling actions
            {
              "action": 'sendNotification',
              "config": {
                "message": 'Cloud Slicer API Error: {value}',
                "type": 'error',
                "extractPath": 'error.error_message'
              }
            },
            {
              "action": 'appendState',
              "config": {
                "state": 'error',
                "messageTemplate": {"title": "Create Failed", "value": "{errorMessage}"},
                "extractMapping": {
                  "errorMessage": 'error.message',
                  "progress_percent": 0
                }
              }
            }
          ]
        }
      },
      '/api2/channel/create': {
        "afterResponse": {
          "actions": [
            {
              "action": 'appendState',
              "config": {
                "state": 'done',
                "messageTemplate": {"title": "Created Channel", "value": "{id}"},
                "extractMapping": {
                  "id": 'data.channel.id',      // Don't Use "state"
                  "state": "data.error"         // Don't Use "state"        
                }
              }
            },
            {
              "action": 'updateSharedParams',
              "config": {
                "extractMapping": {
                  "channel_created": "data.channel.created",
                  "playerURL": "https://content.uplynk.com/channel/{data.channel.id}.m3u8",
                  "channel_id": "data.channel.id"
                }
              }
            },
          ]
        },
        "onError": {
          "actions": [
            {
              "action": 'sendNotification',
              "config": {
                "message": 'Cloud Slicer API Error: {value}',
                "type": 'error',
                "extractPath": 'error.message'
              }
            },
            {
              "action": 'appendState',
              "config": {
                "state": 'error',
                "messageTemplate": {"title": "Channel Fail", "value": "{errorMessage}"},
                "extractMapping": {
                  "errorMessage": 'error.message',    // Don't Use "state"
                  "progress_percent": 0               // Don't Use "state"
                }
              }
            }
          ]
        }
      }
    },
    "elements": []
  },
  "displayOrder": [
    {
      "endpointIndex": 0,
      "paramName": "job_type"
    },
    {
      "endpointIndex": 0,
      "paramName": "slicer_id"
    },
    {
      "endpointIndex": 0,
      "paramName": "url"
    },
    {
      "endpointIndex": 0,
      "paramName": "desc"
    },
    {
      "endpointIndex": 0,
      "paramName": "persist_segments"
    },
    {
      "endpointIndex": 0,
      "paramName": "metadata"
    },
    {
      "endpointIndex": 0,
      "paramName": "state"
    },
    {
      "endpointIndex": 1,
      "paramName": "desc"
    },
    {
      "endpointIndex": 1,
      "paramName": "slicer_id"
    },
    {
      "endpointIndex": 1,
      "paramName": "require_drm"
    },
    {
      "endpointIndex": 1,
      "paramName": "require_studio_drm"
    },
    {
      "type": "button",
      "elementId": "button_1742305595821"
    }
  ],
  "customElements": [
    {
      "id": "button_1742305595821",
      "type": "button",
      "label": "Apply",
      "variant": "primary",
      "action": "submit"
    }
  ]
};